// Mensaje exacto devuelto por el backend cuando el link de firma ha sido invalidado.
export const INVALIDATED_LINK_MESSAGE = 'This signature link has been invalidated';
